import Backbone from 'backbone';

export const FaxRecordModel = Backbone.Model.extend({

	initialize: function( options ) {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

});